export const AUTH_STORAGE_KEYS = {
	ACCESS_TOKEN: "accessToken",
	USER: "user",
} as const

export const AUTH_ERROR_MESSAGES = {
	NO_INIT_DATA: "Не удалось получить данные Telegram. Перезапустите приложение.",
	AUTH_FAILED: "Не удалось авторизоваться. Перезапустите приложение.",
} as const

export const AUTH_ENDPOINTS = {
	TELEGRAM: "/auth/telegram",
	REFRESH: "/auth/refresh",
	ME: "/auth/me",
} as const
